import '../styles/index.css';

import { initConsole } from './console/index.ts';
import { initCopy } from './copy.ts';
import { initIntercom } from './intercom.ts';
import { initNav, initNotFound, initScrollSpy } from './nav.ts';
import { initSearch } from './search.ts';
import { initTabs } from './tabs.ts';
import { initTheme } from './theme.ts';
import { initTryIt } from './tryit/index.ts';

// Marks the document as JS-capable so CSS can hide inactive tab panels. Until this
// runs, every panel is visible — which is exactly what a crawler should see.
document.documentElement.classList.add('js');

initTheme();
initNav();
initTabs();
initCopy();
initSearch();
initScrollSpy();
initIntercom();
initTryIt();
initNotFound();

// Console pages carry a mount point; every documentation page skips this entirely.
if (document.querySelector('[data-console-view]')) void initConsole();
